import React from 'react';

import { GateUpgradeButton } from '../ChatBox/GateUpgradeButton';

import { recordActionClick, recordUserActionClick } from './useActionBarClicks';

/** Work queued for its plan's hourly quota: Upgrade opens the plans whatever the credit balance. */
export const ActionQuotaUpgradeBtn: React.FC<{
  entryId?: string;
  phase: string;
  projectId?: string | null;
  sessionId?: string | null;
}> = ({ entryId, phase, projectId, sessionId }) => (
  <GateUpgradeButton
    source="planning:overview-quota-gate"
    label="Upgrade now"
    onRecord={() => {
      void recordUserActionClick(entryId, phase, 'upgrade', 'Upgrade now', projectId, sessionId);
      void recordActionClick(entryId, phase, 'upgrade', projectId, sessionId);
    }}
  />
);

export const QUOTA_QUEUE_PHASES: ReadonlySet<string> = new Set(['quota_queue', 'quota_queue_build', 'quota_queue_notice']);
